// import React ,{useState}from "react";
// import SearchBar from "../../components/universal/SearchBar";
// import { allchurchHeader } from "./constant";
// import CustomTable from "../../components/universal/CustomTable";
// import { AiOutlinePlus } from "react-icons/ai";
// import { Link, useNavigate,useLocation } from "react-router-dom";
// import { AllChurchHooks } from "./hooks/channelhooks";
// import Navbar from "../../components/universal/Navbar";
// import { confirmAlert } from "react-confirm-alert"; // Import
// import "react-confirm-alert/src/react-confirm-alert.css";
// import ConfirmToast from "../../components/universal/ConfirmToast";
// import LoaderSpinner from "../../components/universal/LoaderSpinner";
// import { useSelector } from "react-redux";
// import ChurchModal from "./channelModal";
// function AllVideos() {
//   const navigate = useNavigate();
//   const { value, onChangeSearchBar, handleDelete, reloadData, setReloadData,fetchAllChurches } =
//   AllChurchHooks();
//   const [isModalOpen, setIsModalOpen] = useState(false); // ✅ modal state
//   const [selectedRow, setSelectedRow] = useState(null); // store clicked row
//      const { userInfo } = useSelector((state) => state.user);
//     const location = useLocation();
//     const hideUI = location.pathname.includes("addfield")|| location.pathname.includes("addMinistryField")|| location.pathname.includes("addChannelField") ;
// const churchadmin=userInfo?.roleCode==='17dwer8'

//   return (
//     <div className="App bg-[#191919] ">

//       <Navbar />
//       <div className="flex-1 md:pl-32 md:pt-0 pt-20">
//         <div className="flex flex-col gap-4 h-full p-2">
//           <SearchBar placeholder={"Search"} value={value} onChangeSearchBar={onChangeSearchBar} />
//           <div className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4">
//             <div className="flex w-full justify-between md:items-center md:flex-row flex-col gap-4 md:mb-0 mb-2">
//               <p className=" text-white text-3xl font-medium">Channels</p>
//               <div className="flex gap-4">
//                 {/* <Link to={"/churches/add"}>
//                   <button className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl">
//                     <AiOutlinePlus /> Add Church
//                   </button>
//                 </Link> */}
//                    <button
//                       // onClick={() => setIsModalOpen(true)}
//   onClick={() => navigate('/addChannelField')}

//                       className=" flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl "
//                     >
//                       <AiOutlinePlus /> Add Channel
//                     </button>
//               </div>
//             </div>
//             <div className="relative bg-[#191919]">

//                     {!isModalOpen?
//               <CustomTable
//                 searchFor="Channels"
//                 heightDesktop={"h-[72vh]"}
//                 width={"w-24"}
//                 // giving extra width to 2nd column
//                 nthChildWidth={
//                   "[&>*:nth-child(1)]:w-40 [&>*:nth-child(2)]:w-40 [&>*:nth-child(3)]:w-40 [&>*:nth-child(3)]:w-32"
//                 }
//                 notificationTable={true}
//                 data={[]}
//                 headers={allchurchHeader}
//                 customDataFetch={true}
//                 customDataFetchFunction={fetchAllChurches}
//                 reloadData={reloadData}
//                 setReloadData={setReloadData}
//                 handleDeleteClick={(row) => {
//                   const options = {
//                     customUI: ({ onClose }) => {
//                       return (
//                         <ConfirmToast
//                           title="Are you sure?"
//                           message="You want to delete this Channel?"
//                           onClose={() => {
//                             onClose();                      // call the original close function
//                           }}
//                           reloadData={reloadData}
//                           onSuccess={async () => {
//                             try {
//                               await handleDelete(row);
//                               setReloadData((prev) => !prev);
//                               onClose();
//                             } catch (err) {
//                               onClose();
//                             }
//                           }}
//                         />
//                       );
//                     },
//                     closeOnEscape: true,
//                     closeOnClickOutside: true,
//                     keyCodeForClose: [8, 32],
//                     overlayClassName: "!bg-gray-500 !bg-opacity-75",
//                   };

//                   confirmAlert(options);

//                 }}
//                 reverseTable={true}
//                 nthChildStyle={"[&>*:nth-child(2)]:h-5 [&>*:nth-child(2)]:overflow-hidden"}
//                 handleToggleClick={(row, isActive) => {
//                 }}
//                 handleEyeClick={(row) => {
//               //  setIsModalOpen(true)
//               //  setSelectedRow(row);
//                // store clicked row
//                   navigate(`/addfield`, {
//                     state: {
//                       church: row || "",
//                     },
//                   });
//                 }}
//                 handleEditClick={(row) => {
//               //  setIsModalOpen(true)
//               //  setSelectedRow(row);
//                // store clicked row
//                   navigate(`/addChannelField`, {
//                     state: {
//                       church: row || "",
//                     },
//                   });
//                 }}
//               />
//               :''
// }
//             </div>
//     <ChurchModal isOpen={isModalOpen}    onClose={() => { setIsModalOpen(false); setSelectedRow(null); }} rowData={selectedRow} // ✅ pass clicked row
//     />

//           </div>
//          </div>
//       </div>
//      </div>
//   );
// }

// export default AllVideos;
import React, { useState, useCallback, useEffect } from "react";
import SearchBar from "../../components/universal/SearchBar";
import { allchurchHeader } from "./constant";
import CustomTable from "../../components/universal/CustomTable";
import { AiOutlinePlus } from "react-icons/ai";
import { FaRegStar, FaStar } from "react-icons/fa6";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AllChurchHooks } from "./hooks/channelhooks";
import Navbar from "../../components/universal/Navbar";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ConfirmToast from "../../components/universal/ConfirmToast";
import LoaderSpinner from "../../components/universal/LoaderSpinner";
import { useSelector, useDispatch } from "react-redux";
import ChurchModal from "./channelModal";
import { updateChannelRequest } from "../../store/Channels/action";
import { toast } from "react-toastify";
import { SUPER_ADMIN } from "../Users/Constants";

function AllVideos() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { value, onChangeSearchBar, handleDelete, reloadData, setReloadData, fetchAllChurches } =
    AllChurchHooks();


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [featuredChannels, setFeaturedChannels] = useState(new Set());
  const [channelOptions, setChannelOptions] = useState([]);
  const [selectedChannelId, setSelectedChannelId] = useState("");
  const { userInfo } = useSelector((state) => state.user);
  const isSuperAdmin = userInfo?.roleCode === SUPER_ADMIN;
  const location = useLocation();
  const hideUI = location.pathname.includes("addfield") || location.pathname.includes("addMinistryField") || location.pathname.includes("addChannelField");
  const tableHeaders = isSuperAdmin
    ? allchurchHeader
    : allchurchHeader.filter((header) => header.headerId !== "featuredColumn");

  useEffect(() => {
    setReloadData(true);
  }, [location.key, setReloadData]);

  // Initialize featured channels from data
  useEffect(() => {
    if (reloadData) {
      setFeaturedChannels(new Set());
    }
  }, [reloadData]);

  // Update channel with featured status
  const updateChannelWithFeatured = useCallback((channelData, isFeatured) => {
    return new Promise((resolve, reject) => {

      const payload = {
        _id: channelData?._id,
        churchName: channelData?.churchName,
        description: channelData?.description,
        logourl: channelData?.logourl,
        featured: isFeatured,
      };
        const callback = (res) => {
        if (res?.type === 1) {
          toast.success(
            isFeatured
              ? "Channel added to featured!"
              : "Channel removed from featured!"
          );
          resolve(res);
        } else {
          toast.error("Failed to update featured channel");
          reject(res);
        }
      };

      dispatch(updateChannelRequest(payload, callback));
    });
  }, [dispatch]);


  // Handle star click - updates the channel via API
  const handleStarClick = useCallback((channel) => {
    const channelId = channel._id;
    const isCurrentlyFeatured = featuredChannels.has(channelId);
    const newStatus = !isCurrentlyFeatured;

    // optimistic UI
    setFeaturedChannels(prev => {
      const next = new Set(prev);
      newStatus ? next.add(channelId) : next.delete(channelId);
      return next;
    });

    updateChannelWithFeatured(channel, newStatus)
      .then(() => {
        setTimeout(() => setReloadData(prev => !prev), 400);
      })
      .catch(() => {
        // rollback
        setFeaturedChannels(prev => {
          const next = new Set(prev);
          isCurrentlyFeatured ? next.add(channelId) : next.delete(channelId);
          return next;
        });
      });
  }, [featuredChannels, updateChannelWithFeatured, setReloadData]);


  // Helper function to clean row data (remove React elements)
  const cleanRowData = useCallback((row) => {
    if (!row) return row;

    const cleanRow = { ...row };

    // Remove the featuredColumn if it exists (it contains React elements)
    if (cleanRow.featuredColumn) {
      delete cleanRow.featuredColumn;
    }

    // Remove any other React elements
    Object.keys(cleanRow).forEach(key => {
      const value = cleanRow[key];
      if (value && typeof value === 'object' && value.$$typeof) {
        delete cleanRow[key];
      }
    });

    // Also remove the isFeatured property we added
    if (cleanRow.isFeatured) {
      delete cleanRow.isFeatured;
    }

    return cleanRow;
  }, []);

  // Create a wrapper function that adds interactive stars to the data
  const fetchAllChannelsWithStars = useCallback(
    (page, limit, search, callbackFn) => {
      fetchAllChurches(page, limit, search, (response) => {
        if (!Array.isArray(response?.data)) {
          callbackFn?.(response);
          return;
        }
        setChannelOptions(response.data);
        localStorage.setItem("channelOptions", JSON.stringify(response.data));
        if (!selectedChannelId && response.data.length > 0) {
          const firstId = response.data[0]?._id || "";
          setSelectedChannelId(firstId);
          if (firstId) {
            localStorage.setItem("channel", JSON.stringify(response.data[0]));
          }
        }

        const featuredSet = new Set();
        response.data.forEach(item => {
          if (item.featured) featuredSet.add(item._id);
        });

        setFeaturedChannels(featuredSet);

        const transformed = response.data.map(channel => {
                    const isFeatured = channel.featured === "true";

          return {
            ...channel,
            isFeatured,
            ...(isSuperAdmin
              ? {
                  featuredColumn: (
                    <div
                      className="flex justify-center items-center cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleStarClick(channel);
                      }}
                      title={isFeatured ? "Remove from featured" : "Add to featured"}
                    >
                      {isFeatured ? (
                        <FaStar className="text-[#EFBC51] text-xl" />
                      ) : (
                        <FaRegStar className="text-gray-400 text-xl hover:text-[#EFBC51]" />
                      )}
                    </div>
                  ),
                }
              : {})
          };
        });

        callbackFn?.({ ...response, data: transformed });
      });
    },
    [fetchAllChurches, handleStarClick, isSuperAdmin, selectedChannelId]
  );

  const handleChannelSelect = (channelId) => {
    setSelectedChannelId(channelId);
    const selected = channelOptions.find((c) => c?._id === channelId);
    if (selected) {
      localStorage.setItem("channel", JSON.stringify(selected));
      window.dispatchEvent(new CustomEvent("channel:change", { detail: selected }));
    }
  };


  return (
    <div className="App bg-[#191919] ">

      <Navbar />
      <div className="flex-1 md:pl-32 md:pt-0 pt-20">
        <div className="flex flex-col gap-4 h-full p-2">
          <SearchBar
            placeholder={"Search"}
            value={value}
            onChangeSearchBar={onChangeSearchBar}
            showChannelDropdown={true}
            channelOptions={channelOptions}
            selectedChannelId={selectedChannelId}
            onChangeChannel={handleChannelSelect}
          />
          <div className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4">
            <div className="flex w-full justify-between md:items-center md:flex-row flex-col gap-4 md:mb-0 mb-2">
              <p className=" text-white text-3xl font-medium">Channels</p>
              <div className="flex gap-4">
                <button
                  onClick={() => {
                    localStorage.removeItem("channel");
                    window.dispatchEvent(
                      new CustomEvent("channel:change", { detail: null })
                    );
                    navigate("/addChannelField", {
                      state: { church: null, mode: "create" },
                    });
                  }}
                  className=" flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl "
                >
                  <AiOutlinePlus /> Add Channel
                </button>
              </div>
            </div>
            <div className="relative bg-[#191919]">
              {!isModalOpen ?
                <CustomTable
                  searchFor="Channels"
                  heightDesktop={"h-[72vh]"}
                  width={"w-24"}
                  // Update nthChildWidth to accommodate the new star column
                  nthChildWidth={
                    isSuperAdmin
                      ? "[&>*:nth-child(1)]:w-40 [&>*:nth-child(2)]:w-40 [&>*:nth-child(3)]:w-40 [&>*:nth-child(4)]:w-32 [&>*:nth-child(5)]:w-20"
                      : "[&>*:nth-child(1)]:w-40 [&>*:nth-child(2)]:w-40 [&>*:nth-child(3)]:w-32 [&>*:nth-child(4)]:w-20"
                  }
                  notificationTable={true}
                  data={[]}
                  headers={tableHeaders}
                  customDataFetch={true}
                  customDataFetchFunction={fetchAllChannelsWithStars}
                  reloadData={reloadData}
                  setReloadData={setReloadData}
                  handleDeleteClick={(row) => {
                    const cleanRow = cleanRowData(row);

                    const options = {
                      customUI: ({ onClose }) => {
                        return (
                          <ConfirmToast
                            title="Are you sure?"
                            message="You want to delete this Channel?"
                            onClose={() => {
                              onClose();
                            }}
                            reloadData={reloadData}
                            onSuccess={async () => {
                              try {
                                await handleDelete(cleanRow);
                                setReloadData((prev) => !prev);
                                onClose();
                              } catch (err) {
                                                                onClose();
                              }
                            }}
                          />
                        );
                      },
                      closeOnEscape: true,
                      closeOnClickOutside: true,
                      keyCodeForClose: [8, 32],
                      overlayClassName: "!bg-gray-500 !bg-opacity-75",
                    };

                    confirmAlert(options);
                  }}
                  reverseTable={true}
                  nthChildStyle={"[&>*:nth-child(2)]:h-5 [&>*:nth-child(2)]:overflow-hidden"}
                  handleToggleClick={(row, isActive) => {
                                      }}
                  handleEyeClick={(row) => {
                    const cleanRow = cleanRowData(row);
                    navigate(`/addfield`, {
                      state: {
                        church: cleanRow || "",
                      },
                    });
                  }}
                  handleEditClick={(row) => {
                    const cleanRow = cleanRowData(row);
                    navigate(`/addChannelField`, {
                      state: {
                        church: cleanRow || "",
                      },
                    });
                  }}
                />
                : ''
              }
            </div>
            <ChurchModal isOpen={isModalOpen} onClose={() => { setIsModalOpen(false); setSelectedRow(null); }} rowData={selectedRow} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllVideos;
